const t = {
  name: "Cash",
  dimensions: { width: 24, height: 17 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15.75H3C1.9 15.75 1 14.85 1 13.75V3.75C1 2.65 1.9 1.75 3 1.75H21C22.1 1.75 23 2.65 23 3.75V13.75C23 14.85 22.1 15.75 21 15.75Z"/>
      <path d="M12 10.75C13.1046 10.75 14 9.85457 14 8.75C14 7.64543 13.1046 6.75 12 6.75C10.8954 6.75 10 7.64543 10 8.75C10 9.85457 10.8954 10.75 12 10.75Z"/>
      <path d="M19 8.75H18"/>
      <path d="M6 8.75L5 8.75"/>
    </g>
  `
};
export {
  t as Cash
};
